var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"game-shell"},[_c('GameContainer'),_c('DeviceOrientationMessage',{attrs:{"isActive":_vm.canShowDeviceOrientationMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }